/*
  eslint-disable
    import/prefer-default-export
*/
export const documentOffsetTop = el => {
  const h = el.offsetTop
  //  + (el.offsetParent ? documentOffsetTop(el.offsetParent) : INITIAL_HEIGHT)
  // console.dir(el);
  return h
}
